import React from "react";
import "./BettingCon.css"


export default function BettingCon({ isClosed }: { isClosed: boolean }) {
  const iconClass = isClosed ? "fa fa-lock" : "fa fa-lock-open";
  
  return (
    <div className={`betting-con ${isClosed ? "betting-con-closed" : ""}`}>
      <i className={`yellow-text ${iconClass}`}></i>
      <span>{isClosed ? "Betting Closed" : "Betting Open"}</span>
    </div>
  )
}